enum APP_TEXT_SIZES {
  // Extra Extra Small
  xxsmall = 10,
  // Extra Small
  xsmall = 11,
  // Small
  small = 12,
  // Standard/Base
  standard = 13,
  // Medium
  medium = 15,
  // Large
  large = 18,
  // Extra Large
  xlarge = 22,
  // 2X Large
  xxlarge = 32,
  // 3X Large
  xxxlarge = 38,
  // Additional sizes for extended typography scale (Figma type scale)
  // B3
  body = 14,
  // B2
  bodyLarge = 16,
  // B1 / H6
  heading6 = 20,
  // H5
  heading5 = 22,
  // H4
  heading4 = 24,
  // H3
  heading3 = 28,
  // H2
  heading2 = 30,
  // H1
  heading1 = 36,
  display = 44,
  displayLarge = 48,
}

export { APP_TEXT_SIZES };
